import { getContexts, Snowplow } from "@simplybusiness/services";
import type { TrackingProps } from "@simplybusiness/services";
import { getInterventionsAirbrake } from "./getInterventionsAirbrake";

const airbrake = getInterventionsAirbrake();

export type InterventionSnowplowParams = {
  uid: string | null; //Analysis UID from Chopin
  duid: string | null; //Duid from Chopin
  appId: string; //Snowplow config from Chopin snippet
  avalancheCollector: string; //Snowplow config from Chopin snippet
  cookieDomain: string; //Snowplow config from Chopin snippet
  site: string; //From Chopin. Used for Airbrake logging.
};

export const getSnowplow = (props: InterventionSnowplowParams) => {
  const trackingProps = {
    uid: props.uid, //NB: This value may be null if a customer doesn't have an analysis_uid yet
    duid: props.duid,
    cookieDomain: props.cookieDomain,
    avalancheCollector: props.avalancheCollector,
    appId: props.appId,
    includeGAContext: false,
    eventMethod: "post",
    postPath: "/com.simplybusiness/events",
    trackActivity: false,
    trackPageView: false,
    forceSecureTracker: true,
  };

  //NB: we still instantiate Snowplow even if we don't have a valid duid
  if (!props.duid) {
    airbrake.notify({
      error: "A null DUID was provided when initialising Snowplow",
      params: {
        source: "mobius-interventions",
        component: "getSnowplow",
        userId: props.duid,
        site: props.site,
      },
    });
  }

  const snowplow = new Snowplow(trackingProps as TrackingProps);
  snowplow.setContexts(getContexts(trackingProps as TrackingProps));

  return snowplow;
};

export const buildInterventionEventBody = (
  interventionName: string,
  duid: string,
  site: string,
  action: string,
) => {
  return {
    schema:
      "iglu:com.simplybusiness/intervention_interaction_completed/jsonschema/2-1-0",
    data: {
      intervention_name: interventionName,
      user_unique_identifier: duid,
      user_unique_identifier_type: "duid",
      action: action,
      site: site,
    },
  };
};
